// extracted by mini-css-extract-plugin
module.exports = {"menu":"ContextMenu_menu__16WKY","entry":"ContextMenu_entry__3qLrF","isDisabled":"ContextMenu_isDisabled__3EkLr"};